<div class="capital-investment-summary-leader-container p-0">
    <div class="uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
        <div class="uitk-c-card uhc-font p-3 leader-page-min-height">
            <div class="row segLeaderToggle">
                <div class="d-flex justify-content-end align-items-center toggle-div">
                    <span class="switch-toggle-label me-1  toggle-ytd-label"
                      >Segment</span>
                    <mat-slide-toggle [color]="'#013b71'" class="toggle-margin app-toggle" [(ngModel)]="checked" (change)="onToggleChange($event.checked)">
                    </mat-slide-toggle>
                    <span class="switch-toggle-label ms-1 toggle-ytd-label">Leader</span>
                </div>
            </div>
            <div class="filter-section row">
                <div class="form-group col-2 custom-pl-15">
                    <app-dropdown-with-search [Pixeltracking]="true" searchFlag="false" placeholder="Fiscal Year"
                        showPlaceholder="true" isMultiSelect="false" [dropdownData]="yearList" [selected]="selectedYr"
                        (selectionChange)="onYearChange($event)"></app-dropdown-with-search>
                </div>
                <div class="form-group col-2">
                    <app-dropdown-with-search [Pixeltracking]="true" searchFlag="false" placeholder="Investment Status"
                        showPlaceholder="true" isMultiSelect="true" [dropdownData]="statusList"
                        [selected]="selectedStatusList"
                        (selectionChange)="setSelectedValues($event,'status')"></app-dropdown-with-search>
                </div>
                <div class="form-group col-2 leader-width">
                     <app-hierarchy-dropdown [dropdownData]="leaderdropdwnDataSource"
                       [selectValues]="selectValues"
                       [filterKey]="'L1:L2:L3'"
                       [resetTrigger]="resetTrigger"
                       (selectionChange)="setSelectedLeaderValues($event)"
                       [placeholderText]="'Select Leader(s)'">
                   </app-hierarchy-dropdown>
                </div>
                <div class="leader-width-container">
                    <div class="table-header-icons table-header-icons-buttons col-2 searchResetExcelButtons">
                        <button [disabled]="searchBtnDisable()" (click)="searchSegmentDetails()"
                            class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs searchResetCSS">Search</button>
                            <button
                            [disabled]="disableReset"
                            class="removebuttonClass m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs searchResetCSS"
                            (click)="refresh()"
                        >
                            Reset
                        </button>
                        <ng-container *ngIf="this.filteredData && this.filteredData.length">
                            <div
                                class="export-link col-2">
                                <span title="Click to Download"
                                (click)="exportToCsv()"
                                class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"></span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- KPIs -->
            <div *ngIf="showKPI" class="details-card details-card-margin">
                <div class="card-structure optum-font">
                    <div class="top-card-hlist">
                        <div class="top-card-hlist-items">
                            <div class="top-card-hlist-box">
                                <div class="top-card-hlist-pill-headers hlist-titles">Leader OT Allocation</div>
                                <div class="pill-detail preferred">
                                    <span class="pill-moneyfield">${{ leaderOTAllocationKPI.value | BillionsToBMillionsToMThousandsToK }}</span>
                                </div>
                            </div>
                        </div>
                      <div class="top-card-hlist-items">
                            <div class="top-card-hlist-box">
                                <div class="top-card-hlist-pill-headers hlist-titles">Leader Run Rate</div>
                                <div class="pill-detail preferred">
                                    <span class="pill-moneyfield">${{ leaderRunRateKPI.value | BillionsToBMillionsToMThousandsToK }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="top-card-hlist-items">
                            <div class="top-card-hlist-box">
                                <div class="top-card-hlist-pill-headers hlist-titles">Leader Variance</div>
                                <div class="pill-detail preferred">
                                    <span class="pill-moneyfield">${{ leaderVarianceKPI.value | BillionsToBMillionsToMThousandsToK }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row filter-result-section">
                <!-- Needs to be done -->
                
                <div class="no-records-found p-5" *ngIf="!showLoader && filteredData?.length ==0">
                    <div class="img-align">
                        <img class="image-align" src="/assets/images/warning-icon.svg" />
                    </div>
                    <div class=" data-title">
                        <div class="errorTitle">No Data Available</div>
                    </div>
                </div>
                <div class="stk-table-container">
                    <div class="d-flex justify-content-center" *ngIf="showLoader">
                        <app-loader>
                        </app-loader>
                    </div>
                    <div class="tableAndAddSearchBoxWrapper">
                        
                        <div class="otl-tables-container">
                        <div class="otl-table" *ngFor="let L1leaders of filteredData; let i = index">
                            <table mat-table [dataSource]="L1leaders" [multiTemplateDataRows]="true">
                                  
                                  <ng-container *ngIf="i === 0">
                                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                  </ng-container>
                
                                  <!-- Load Columns -->
                                  <ng-container matColumnDef="department_leader">
                                      <th mat-header-cell *matHeaderCellDef class="department-leader-header fixed-width-cell">
                                          <button class="expand-all-button" mat-icon-button  *ngIf="!expandCollapseAll" (click)="expandAll()">
                                              <mat-icon>navigate_next</mat-icon>
                                          </button>
                                          <button class="expand-all-button" mat-icon-button *ngIf="expandCollapseAll" (click)="collapseAll()">
                                              <mat-icon>expand_more</mat-icon>
                                          </button>
                                          &nbsp;&nbsp;Department Leader                
                                      </th>
                                      <td mat-cell *matCellDef="let element" 
                                          class="department-leader-cell fixed-width-cell" style="border-radius: 4px;">
                                          <div style="display:flex; align-items: center;" [ngClass]="{'level-1': element.level == 'L1', 'level-2': element.level == 'L2', 
                                          'level-3': element.level == 'L3', 'level-4': element.level == 'L4', 'level-5': element.level == 'L5', 'level-6': element.level == 'L6', 'level-7': element.level == 'L7', 'level-8': element.level == 'L8'}">
                                              <button class="tableExpandButton" (click)="toggleExpanded(element)" *ngIf="shouldShowExpandIcon(element)">
                                                  <mat-icon class="expand-down-icon" *ngIf="!element.expanded" style="z-index: 100px;">navigate_next</mat-icon>
                                                  <mat-icon class="expand-left-icon" alt="Expanded" *ngIf="element.expanded" style="z-index: 100px;">expand_more</mat-icon>
                                              </button>
                                              <div class="circle" [ngClass]="{'extra-margin' :!shouldShowExpandIcon(element)}"><span>{{element.level}}</span></div>
                                              <div style="display: inline-block;">
                                                <div [ngClass]="{'highlighted-leader': element.isHighlighted}">
                                                    {{element.Leader_Name}}
                                                </div>
                                              </div>
                                          </div>
                                      </td>
                                  </ng-container>

                                  <ng-container matColumnDef="ucmg_count">
                                    <th mat-header-cell *matHeaderCellDef class="optum-tech-labour-header fixed-width-cell"> UCMG Count </th>
                                    <td mat-cell *matCellDef="let element" class="optum-tech-labour-cell fixed-width-cell"> 
                                        <ng-container>
                                            <a href="javascript:void(0)" (click)="generateLink(element)" rel="noopener">
                                            {{ element.ucmg_count || 0 }}
                                            </a>
                                        </ng-container>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="leader_ot_allocation">
                                    <th mat-header-cell *matHeaderCellDef class="optum-tech-labour-header fixed-width-cell"> Leader OT Allocation </th>
                                    <td mat-cell *matCellDef="let element" class="optum-tech-labour-cell fixed-width-cell"> 
                                        <ng-container>
                                            {{ (element.leader_ot_allocation | currency:'USD':'symbol':'1.0-0') || 0}} 
                                        </ng-container>
                                    </td>
                                </ng-container>


                                <ng-container matColumnDef="leader_ot_actuals">
                                    <th mat-header-cell *matHeaderCellDef class="optum-tech-labour-header fixed-width-cell"> Leader OT Actuals </th>
                                    <td mat-cell *matCellDef="let element" class="optum-tech-labour-cell fixed-width-cell"> 
                                        <ng-container>
                                            {{ (element.leader_ot_actuals | currency:'USD':'symbol':'1.0-0') || 0}} 
                                        </ng-container>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="totalRunRate">
                                    <th mat-header-cell *matHeaderCellDef class="optum-tech-labour-header fixed-width-cell"> Leader Run Rate </th>
                                    <td mat-cell *matCellDef="let element" class="optum-tech-labour-cell fixed-width-cell"> 
                                        <ng-container>
                                            {{ (element.totalRunRate | currency:'USD':'symbol':'1.0-0') || 0}} 
                                        </ng-container>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="leader_variance">
                                    <th mat-header-cell *matHeaderCellDef class="optum-tech-labour-header fixed-width-cell"> Leader Variance </th>
                                    <td mat-cell *matCellDef="let element" class="optum-tech-labour-cell fixed-width-cell"> 
                                        <ng-container>
                                            {{ (element.leader_variance | currency:'USD':'symbol':'1.0-0') || 0}} 
                                        </ng-container>
                                    </td>
                                </ng-container>
                                  
                <!-- Render all rows -->
                                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="border: 1px solid #D3C9C9 !important;"></tr>
                                 
                            </table>
                        </div>
                        </div> <!--wrapper  -->
                        <!-- Add Leader Component -->
                        <div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</div>